const restclient = require('nordic/restclient');

const request = restclient({
  baseURL: '',
  timeout: 30000,
});

module.exports = {
  path: '/developers/:lang/reference',
  exact: false,
  resolve: () => require.ensure([], require => require('../view'), 'reference.chunk'),
  webpack: () => require.resolveWeak('../view'),
  fetchData: (params, state, history) => {
    const endpoint = history.location.pathname;
    const actualUrl = {
      host: `https://${window.location.host}`,
      path: history.location.pathname,
      fullPath: history.location.pathname + history.location.search,
    };
    if (endpoint.match(/\/developers\/(pt|en|es)\/reference$/g)) {
      return {
        referenceContent: null,
        actualUrl,
      };
    }
    return request.get(`/developers/api/reference${endpoint}`)
      .then((response) => ({
        referenceContent: response.data,
        actualUrl,
      }));
  },
};
